import React from 'react';
import { Link } from 'react-router-dom';
interface FooterProps {
  count?: number;
}
const Footer: React.FC<FooterProps> = ({
  count = 0
}) => {
  return <footer className="border-t border-white/10 py-12 px-6 md:px-12 bg-black" data-id="element-41">
      <div className="max-w-screen-2xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-8 md:space-y-0" data-id="element-42">
        <div className="text-sm text-zinc-500 tracking-tight font-medium" data-id="element-43">
          My100builds — 2026
        </div>
        <div className="flex items-center space-x-8 text-xs font-semibold text-zinc-400 uppercase tracking-widest" data-id="element-44">
          <Link to="/projects" className="hover:text-white transition-colors cursor-target" data-id="element-45">
            projects
          </Link>
          <Link to="/about" className="hover:text-white transition-colors cursor-target" data-id="element-46">
            about
          </Link>
          <Link to="/notes" className="hover:text-white transition-colors cursor-target" data-id="element-47">
            thoughts
          </Link>
          <Link to="/contact" className="hover:text-white transition-colors cursor-target" data-id="element-48">
            contact
          </Link>
        </div>
        <div className="flex items-center space-x-4" data-id="element-49">
          <a href="#" className="text-zinc-500 hover:text-white transition-colors text-xl cursor-target" data-id="element-50">
            <span className="sr-only" data-id="element-51">YouTube</span>
            📺
          </a>
          <a href="#" className="text-zinc-500 hover:text-white transition-colors text-xl cursor-target" data-id="element-52">
            <span className="sr-only" data-id="element-53">Twitter</span>
            🐦
          </a>
        </div>
      </div>
      <div className="mt-8 flex justify-center" data-id="element-54">
        <div className="flex items-center bg-zinc-900 border border-white/10 rounded-full px-4 py-2 space-x-3 cursor-default" data-id="element-55">
          <span className="w-2 h-2 rounded-full bg-[#00FF5C] animate-pulse" data-id="element-56"></span>
          <span className="text-[10px] uppercase tracking-widest text-zinc-400 font-bold" data-id="element-57">
            100 builds challenge: {count}/100 shipped
            <span className="mx-2 text-zinc-600" data-id="element-58">|</span>
            <span className="text-zinc-500" data-id="element-59">more in progress</span>
          </span>
        </div>
      </div>
    </footer>;
};
export default Footer;